import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { useCombineRefs } from "../../hooks/useCombineRefs";
import { useUniqueId } from "../../hooks/useUniqueId";
import { Field } from "../field/Field";
import { defaultDateFormat } from "../date-input/dateFormats";
import { DateInput } from "../date-input/DateInput";
import { CalendarButton } from "./CalendarButton";
export const useDateField = ({ ref, dateFormat = defaultDateFormat, status: statusProp, date, layoutVariant, calendarRef, label, isToggleLabelImplicit, inputProps, inputRef: inputRefProp, placeholder, disabled, onCalendarButtonPress, validate, hasFocus, onFocusOutside, onBlur, onDateChange, hasPopover, stringMap, shouldValidateOnBlur, ...props }) => {
    const [validationMessage, setValidationMessage] = useState(statusProp);
    const calendarButtonRef = useRef(null);
    const inputRef = useRef(null);
    const combinedInputRef = useCombineRefs(inputRef, inputRefProp);
    const labelId = useUniqueId("uid");
    const isFocusedOutside = (relatedTarget) => !(inputRef.current?.contains(relatedTarget) ||
        calendarButtonRef.current?.contains(relatedTarget) ||
        calendarRef?.current?.contains(relatedTarget));
    return {
        setValidationMessage,
        calendarButtonRef,
        labelId,
        inputRef,
        dateField: (_jsx(Field, { ref: ref, "data-testid": "DatePicker", layoutVariant: layoutVariant, label: label, labelId: labelId, status: statusProp || validationMessage, disabled: disabled, onBlur: (e) => {
                if (isFocusedOutside(e.relatedTarget)) {
                    if (shouldValidateOnBlur && validate !== false) {
                        setValidationMessage(inputRef.current?.validationMessage);
                    }
                    onFocusOutside?.(e);
                }
                onBlur?.(e);
            }, input: _jsx(DateInput, { ref: combinedInputRef, date: date, hasFocus: hasFocus, dateFormat: dateFormat, validate: validate, placeholder: placeholder, disabled: disabled, stringMap: stringMap, onDateChange: (date) => {
                    onDateChange(date);
                    if (validate !== false) {
                        setValidationMessage("");
                    }
                }, ...inputProps, children: _jsx(CalendarButton, { disabled: disabled || !hasPopover, ref: calendarButtonRef, implicitLabelId: isToggleLabelImplicit ? undefined : labelId, label: stringMap.toggleCalendar, onTouchStart: onCalendarButtonPress, onMouseDown: onCalendarButtonPress }) }), ...props }))
    };
};
